import { render, staticRenderFns } from "./BusCard.vue?vue&type=template&id=74fca592&scoped=true&lang=html&"
import script from "./BusCard.vue?vue&type=script&lang=js&"
export * from "./BusCard.vue?vue&type=script&lang=js&"
import style0 from "./BusCard.vue?vue&type=style&index=0&id=74fca592&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fca592",
  null
  
)

export default component.exports